module.exports = __webpack_public_path__ + "img/Hydra.3bab1f66.png";